//#region Imports

import { FormLabels } from "../../types";

//#endregion

//#region Default Form Labels

// English defaults for form labels
export const DEFAULT_FORM_LABELS = {
  feedback_form: {
    tooltip_thumbs_up: "Helpful",
    tooltip_thumbs_down: "Unhelpful",
    form_heading_line: "Tell us more...",
    feedback_text_placeholder: "Please help us understand how we can improve",
    quick_replies: ["Unclear", "Not factually correct", "Incomplete", "Correct, but not helpful", "Too Long"],
    send_button_label: "Send Feedback",
    send_button_sending: "Sending...",
    feedback_success: "Feedback sent successfully!",
    feedback_fail: "Unable to send feedback.",
    close_modal: "Close",
  },
  send_transcript_form: {
    tooltip: "Send Transcript",
    form_heading_line1: "Send a copy of the conversation transcript",
    form_heading_line2: "to the specified email address.",
    email_placeholder: "Your Email",
    email_invalid: "Please enter a valid email address.",
    sharewith_placeholder: "Share With",
    sharewith_help: "Separate with commas for multiple emails",
    sharewith_invalid: "One or more email addresses are invalid.",
    note_placeholder: "Add a note (optional)",
    note_help: "This note will be included with the transcript email",
    send_button_label: "Send Transcript",
    send_button_sending: "Sending...",
    wait_before_resending: "Please wait 60 seconds before sending another transcript.",
    close_modal: "Close",
    error_sharewith_invalid: "Please enter either 'support' or valid emails.",
    error_sharewith_max_emails: "You can share with up to 5 email addresses only.",
    error_sharewith_duplicates: "Duplicate email addresses are not allowed.",
    error_unexpected: "An unexpected error occurred. Please try again later.",
    error_missing_recipient: "One field is required: either your email or share with.",
    error_invalid_request: "Invalid parameters provided for the request.",
    success_transcript_queued: "Request received, transcript will be sent shortly.",
    error_send_failed: "Failed to send transcript. Please try again.",
  },
  language_selector: {
    tooltip: "Select Language",
  },
  info_button: {
    tooltip: "Terms and Conditions",
  },
} satisfies FormLabels;

//#endregion
